module.exports = __webpack_public_path__ + "608a0f432e5efda4657a07ce9e5a67fc.svg";